<template>
	<div>
  		<VictimsInfo/>
  		<VictimsTable/>
	</div>
</template>

<script>
import User from "@/apis/User";
import VictimsTable from '@/components/victims/table.vue'
import VictimsInfo from '@/components/victims/info.vue'

export default  {

	name : "victims",
	components : {
		VictimsTable,
		VictimsInfo
	}
};
</script>
